import getters from './getters'
import { actions as actions } from './actions'
import { mutations } from './mutations'

const state = {
  order: {
    loading: true,
    data: null,
    error: false
  },
  orders: {
    loading: true,
    data: null,
    error: false
  },
  orderDetail: {
    loading: true,
    data: null,
    error: false
  },
  stripe: {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/order/index.js
// module id = null
// module chunks = 